import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  console.log({ response })

  const data = isSuccessResponse(response)

  return data?.map((item: any) => ({
    id: item?.id,
    key: item?.key,
    bankingCodeData: {
      //   type: 'bankingCode',
      id: !isNaN(Number(item?.key)) ? Number(item?.key) : undefined,
      code: item?.object?.code,
      name: item?.object?.name,
      type: item?.object?.type,
      status: item?.object?.status ? 'true' : 'false',
      description: item?.object?.description,
      extraField1: item?.object?.extraField1,
      extraField2: item?.object?.extraField2,
    },
    data: {},
    type: item?.type,
    className: item?.className,
    username: item?.username,
    approvalStatus: item?.approvalStatus,
    approvalType: item?.approvalType,
  }))
}

const getBankCodeApprovals = (elevated: boolean, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.pendingApprovalsOfBankingCodes),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      elevated,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getBankCodeApprovals }
